<template>
    <div class="task-card mt-0" :class="{'is-toggling': isToggling, 'text-danger': (isTaskOverdue(task) && !taskComplete)}" >
        <edit-task-modal @task-updated="handleTaskUpdated" :task="task"></edit-task-modal>
        <div class="d-flex align-items-center inner">
            <div class="flex-grow-1 d-flex align-items-center">
                <!-- <b class="task-name" :class="{'text-white': isTaskOverdue(task)}">{{ task.agent.name }}</b> -->
                <div class="mb-1 d-flex align-items-top" v-if="task.description">
                <div class="flex-shrink-1 pr-2 checkbox-container">
                    <input @change="handleCheckboxChanged" :checked="taskComplete" type="checkbox"
                           :disabled="isToggling">
                </div>
                <div class="flex-grow-1">
                    <strike v-if="taskComplete">{{ task.description }}</strike>
                    <span v-else>{{ task.description }}</span>

                    <div v-if="task.deadline">
                        <i class="fa fa-clock"></i>
                        {{ displayTimestamp(task.deadline) }}
                    </div>
                </div>
            </div>
          
            </div>
            <div class="flex-shrink-1">
                <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 mt-2">
                    <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18" :class="{'text-danger': (isTaskOverdue(task) && !taskComplete)}"></i>
                    </template>
                    <b-dropdown-item @click="edit">Edit</b-dropdown-item>
                    <b-dropdown-item @click="requestDelete" variant="danger">Delete</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <!-- <div class="inner inner-bottom">
            <div class="mb-1 d-flex align-items-top" v-if="task.description">
                <div class="flex-shrink-1 pr-2 checkbox-container">
                    <input @change="handleCheckboxChanged" :checked="taskComplete" type="checkbox"
                           :disabled="isToggling">
                </div>
                <div class="flex-grow-1">
                    <strike v-if="taskComplete">{{ task.description }}</strike>
                    <span v-else>{{ task.description }}</span>
                </div>
            </div>
            <div v-if="task.deadline">
                <i class="fa fa-clock"></i>
                {{ displayTimestamp(task.deadline) }}
            </div>
        </div> -->
    </div>
</template>

<script>
    import axios from "axios";
    import {mapGetters, mapActions} from "vuex";
    import EditTaskModal from "./Task/EditTaskModal";
    import Dates from "../../../../../mixins/Dates";
    import Tasks from "../../../../../mixins/Tasks";
    import eventBus from "../../../../../event-bus";

    export default {
        name: "Task",
        components: {EditTaskModal},
        props: ['task'],
        mixins: [Dates, Tasks],

        data() {
            return {
                taskComplete: this.task.completed_at !== null,
                isToggling: false
            }
        },

        methods: {
            ...mapActions('ticketViewer', {
                reloadTicket: 'reloadTicket',
                updateLocalTask: 'updateLocalTask'
            }),

            edit() {
                this.$bvModal.show('edit-task-' + this.task.id + '-modal');
            },

            requestDelete() {
                let vm = this;
                swal({
                    title: "Are you sure you want to delete this task?",
                    icon: "warning",
                    buttons: {
                        cancel: true,
                        confirm: "Delete"
                    },
                    dangerMode: true,
                }).then((shouldDelete) => {
                    if (shouldDelete) {
                        vm.delete();
                    }
                });
            },

            delete() {
                let vm = this;
                vm.isSaving = true;
                axios.delete(API_BASE + '/tickets/' + this.ticket.id + '/tasks/' + vm.task.id).then(r => {
                    vm.isSaving = false;
                    vm.reloadTicket();
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Task deleted successfully'
                    });
                }).catch(e => {
                    vm.isSaving = false;
                    vm.notifyErrors(e);
                });
            },

            handleTaskUpdated() {
                this.reloadTicket();
            },

            handleCheckboxChanged() {
                let vm = this;
                vm.isToggling = true;
                axios.post(API_BASE + '/tickets/' + this.ticket.id + '/tasks/' + vm.task.id + '/toggle-completed').then(r => {
                    vm.isToggling = false;
                    vm.taskComplete = !vm.taskComplete;
                    vm.updateLocalTask(r.data);
                    eventBus.$emit('task-toggled', vm.task);
                }).catch(e => {
                    vm.isToggling = false;
                    vm.notifyErrors(e);
                });
            }
        },

        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket'
            })
        }
    }
</script>

<style scoped lang="scss">
    .task-card {
        background: #fff;
        border-radius: 5px;

        &.is-toggling {
            opacity: 0.6;

            &:hover {
                cursor: not-allowed;
            }
        }

        .task-name {
            font-weight: 600;
            color: #2c5cc5;
        }

        .inner {
            // padding-left: 15px;
            // padding-right: 15px;
        }

        .checkbox-container {
            padding-top: 2px;
        }

        .inner-bottom {
            padding-top: 0;
            // padding-bottom: 12px !important;
            font-size: 12px;
        }
    }
</style>
